import { BookingChannel } from "../../classes";

const BookingChannelModule = {
  namespaced: true,
  state: {
    bookingChannels: []
  },
  mutations: {
    setBookingChannels: (state, bookingChannels) => {
      state.bookingChannels = bookingChannels;
    },
  },
  getters: {
    getBookingChannels: state => {
      return state.bookingChannels.filter(d => !d.isRemoved)
    },
    getBookingChannelNameOnly: state => state.bookingChannels.map(i => ({ objectId: i.objectId, name: i.name })),
  },
  actions: {
    getBookingChannels: async ({ commit }, projectId) => {
      try {
        const data = await BookingChannel.getBookingChannels(projectId);
        commit("setBookingChannels", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    createBookingChannel: async ({ commit }, formData) => {
      try {
        const data = await BookingChannel.createBookingChannel(formData);
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateBookingChannel: async ({ }, formData) => {
      try {
        const data = await BookingChannel.updateBookingChannel(formData);
        return data;
      } catch (err) {
        throw err;
      }
    },
    removeBookingChannel: async ({ }, id) => {
      try {
        const data = await BookingChannel.removeBookingChannel(id)
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
};
export default BookingChannelModule;
